import { TagSchema, validateEmail, validatePhone, AddressSchema, PhoneSchema, } from '../index.js';
import { CaseStatus, EndReasonId, SystemEndReason } from '../cases/index.js';
import helpers from '../economy/helpers/index.js';
import { Lang } from '../lang/Lang.js';
import { EBoksRecipientSchema } from '../interactions/eboks.js';
import { ISINCOURTUPDATESTYPES } from '../tribunal/index.js';
import { z } from 'zod/v4';
export var RKIStates;
(function (RKIStates) {
    RKIStates["REPORTED"] = "REPORTED";
    RKIStates["ERROR"] = "ERROR";
    RKIStates["PUBLISHED"] = "PUBLISHED";
    RKIStates["DELETED"] = "DELETED";
    RKIStates["CONCLUDED"] = "CONCLUDED";
})(RKIStates || (RKIStates = {}));
export var DeleteReasons;
(function (DeleteReasons) {
    DeleteReasons["BET"] = "BET";
    DeleteReasons["AIN"] = "AIN";
    DeleteReasons["D\u00D8D"] = "D\u00D8D";
    DeleteReasons["TFY"] = "TFY";
    DeleteReasons["GAL"] = "GAL";
    DeleteReasons["VTT"] = "VTT";
    DeleteReasons["TAF"] = "TAF";
    DeleteReasons["STR"] = "STR";
    DeleteReasons["DER"] = "DER";
})(DeleteReasons || (DeleteReasons = {}));
export const RKIDeleteReasonsCaseEndMapper = (endReasonId) => {
    switch (endReasonId) {
        case EndReasonId[SystemEndReason.Paid]:
        case EndReasonId[SystemEndReason.PartiallyPaid]:
        case EndReasonId[SystemEndReason.Overpayment]:
            return DeleteReasons.BET;
        case EndReasonId[SystemEndReason.OfferFromDebtor]:
        case EndReasonId[SystemEndReason.OfferFromUs]:
            return DeleteReasons.AIN;
        case EndReasonId[SystemEndReason.DebtRelief]:
            return DeleteReasons.GAL;
        case EndReasonId[SystemEndReason.Dead]:
            return DeleteReasons.DØD;
        case EndReasonId[SystemEndReason.Objection]:
        case EndReasonId[SystemEndReason.ConflictOfInterest]:
            return DeleteReasons.STR;
        case EndReasonId[SystemEndReason.Merged]:
            return null;
        default:
            return DeleteReasons.DER;
    }
};
export var SecondaryEmailType;
(function (SecondaryEmailType) {
    SecondaryEmailType["To"] = "TO";
    SecondaryEmailType["CC"] = "CC";
    SecondaryEmailType["BCC"] = "BCC";
})(SecondaryEmailType || (SecondaryEmailType = {}));
export var DissolvedStatus;
(function (DissolvedStatus) {
    DissolvedStatus["UnderLiquidation"] = "UNDERLIQUIDATION";
    DissolvedStatus["DissolvedAfterLiquidation"] = "DISSOLVEDAFTERLIQUIDATION";
    DissolvedStatus["InvoluntaryDissolution"] = "INVOLUNTARYDISSOLUTION";
    DissolvedStatus["Dissolved"] = "DISSOLVED";
})(DissolvedStatus || (DissolvedStatus = {}));
export var AlternativeContactType;
(function (AlternativeContactType) {
    AlternativeContactType["Lawyer"] = "LAWYER";
    AlternativeContactType["Proprietorship"] = "PROPRIETORSHIP";
    AlternativeContactType["Guardian"] = "GUARDIAN";
    AlternativeContactType["Owner"] = "OWNER";
    AlternativeContactType["Curator"] = "CURATOR";
    AlternativeContactType["Landlord"] = "LANDLORD";
    AlternativeContactType["FinancialAdvisor"] = "FINANCIALADVISOR";
    AlternativeContactType["TaxAuthority"] = "TAXAUTHORITY";
    AlternativeContactType["PowerOfAttorney"] = "POWEROFATTORNEY";
    AlternativeContactType["Administrator"] = "ADMINISTRATOR";
    AlternativeContactType["Police"] = "POLICE";
    AlternativeContactType["Guarantor"] = "GUARANTOR";
    AlternativeContactType["Other"] = "OTHER";
})(AlternativeContactType || (AlternativeContactType = {}));
export var RelationType;
(function (RelationType) {
    RelationType["Cosmo"] = "COSMO";
    RelationType["CustomerReferenceId"] = "CUSTOMER_REFERENCE_ID";
    RelationType["Email"] = "EMAIL";
    RelationType["CPR"] = "CPR";
    RelationType["CVR"] = "CVR";
    RelationType["NameAddress"] = "NAME_ADDRESS";
})(RelationType || (RelationType = {}));
export var CompanyStarCycle;
(function (CompanyStarCycle) {
    CompanyStarCycle["Active"] = "ACTIVE";
    CompanyStarCycle["Inactive"] = "INACTIVE";
    CompanyStarCycle["OperationsCeased"] = "OPERATIONSCEASED";
    CompanyStarCycle["ShelfCompany"] = "SHELFCOMPANY";
})(CompanyStarCycle || (CompanyStarCycle = {}));
export var AKSCPRStatus;
(function (AKSCPRStatus) {
    AKSCPRStatus["Active"] = "AKT";
    AKSCPRStatus["Dead"] = "D\u00D8D";
    AKSCPRStatus["Disappeared"] = "FSV";
    AKSCPRStatus["Greenland"] = "GRL";
    AKSCPRStatus["NoPermanentResidence"] = "UDB";
    AKSCPRStatus["GoneAway"] = "UDR";
    AKSCPRStatus["ForTaxReason"] = "SKT";
    AKSCPRStatus["NotVerified"] = "ICV";
})(AKSCPRStatus || (AKSCPRStatus = {}));
export var AKSKOBStatus;
(function (AKSKOBStatus) {
    AKSKOBStatus["Active"] = "AKT";
    AKSKOBStatus["Inactive"] = "INA";
    AKSKOBStatus["OperationsCeased"] = "OPH";
    AKSKOBStatus["ShelfCompany"] = "SKU";
})(AKSKOBStatus || (AKSKOBStatus = {}));
export var FoundationCode;
(function (FoundationCode) {
    FoundationCode["betalingsp\u00E5krav1p\u00E5tegning"] = "A";
    FoundationCode["betalingsp\u00E5krav2p\u00E5tegning"] = "B";
    FoundationCode["st\u00E6vning"] = "C";
    FoundationCode["fogedsag"] = "D";
    FoundationCode["dom"] = "E";
    FoundationCode["insolvens"] = "F";
    FoundationCode["konkurs"] = "I";
    FoundationCode["tvangsakkord"] = "K";
    FoundationCode["retsforlig"] = "L";
    FoundationCode["fogedretsrekv"] = "P";
    FoundationCode["offentliginberetning"] = "S";
    FoundationCode["tvangsauktion"] = "T";
    FoundationCode["tvangsauktionudl\u00E6g"] = "U";
    FoundationCode["g\u00E6ldssanering"] = "W";
    FoundationCode["skylderkl\u00E6ring"] = "Y";
    FoundationCode["forlig"] = "Z";
    FoundationCode["speciel"] = "X";
})(FoundationCode || (FoundationCode = {}));
export var AKSStatus;
(function (AKSStatus) {
    AKSStatus["ENROLLED"] = "ENROLLED";
    AKSStatus["LEAVED"] = "LEAVED";
})(AKSStatus || (AKSStatus = {}));
export var PrivateStarCycle;
(function (PrivateStarCycle) {
    PrivateStarCycle["Active"] = "ACTIVE";
    PrivateStarCycle["Dead"] = "DEAD";
    PrivateStarCycle["Disappeared"] = "DISAPPEARED";
    PrivateStarCycle["GoneAway"] = "GONEAWAY";
    PrivateStarCycle["Homeless"] = "HOMELESS";
    PrivateStarCycle["ForTaxReason"] = "FORTAXREASON";
    PrivateStarCycle["NotVerified"] = "NOTVERIFIED";
})(PrivateStarCycle || (PrivateStarCycle = {}));
export const deleteReasonTexts = {
    [DeleteReasons.BET]: 'Fordring betalt',
    [DeleteReasons.AIN]: 'Aftale indgået med skyldner',
    [DeleteReasons.DØD]: 'Skyldner er afgået ved døden',
    [DeleteReasons.TFY]: 'Tvangsakkord fyldestgjort',
    [DeleteReasons.GAL]: 'Gældssanering - al gæld bortfalder',
    [DeleteReasons.VTT]: 'Varen taget retur',
    [DeleteReasons.TAF]: 'Tvangsauktion aflyst',
    [DeleteReasons.STR]: 'Der er strid i sagen',
    [DeleteReasons.DER]: 'Andet - vi ønsker skyldner slettet',
};
export const AKSStageMap = {
    [AKSCPRStatus.Dead]: PrivateStarCycle.Dead,
    [AKSCPRStatus.Disappeared]: PrivateStarCycle.Disappeared,
    [AKSCPRStatus.Greenland]: PrivateStarCycle.GoneAway,
    [AKSCPRStatus.NoPermanentResidence]: PrivateStarCycle.Homeless,
    [AKSCPRStatus.GoneAway]: PrivateStarCycle.GoneAway,
    [AKSCPRStatus.ForTaxReason]: PrivateStarCycle.ForTaxReason,
    [AKSCPRStatus.NotVerified]: PrivateStarCycle.NotVerified,
    [AKSCPRStatus.Active]: PrivateStarCycle.Active || CompanyStarCycle.Active,
    [AKSKOBStatus.Inactive]: CompanyStarCycle.Inactive,
    [AKSKOBStatus.OperationsCeased]: CompanyStarCycle.OperationsCeased,
    [AKSKOBStatus.ShelfCompany]: CompanyStarCycle.ShelfCompany,
};
export const validateNewUserOnCustomer = (customer, newUser) => {
    if (!newUser)
        return false;
    if (!newUser?.details)
        return false;
    if (!(newUser.relation &&
        ['debtor', 'alternative-contact'].includes(newUser?.relation))) {
        return false;
    }
    if (typeof newUser.contact !== 'boolean') {
        return false;
    }
    if (newUser.relation === 'alternative-contact' &&
        !Object.values(AlternativeContactType).includes(newUser.details.type))
        return false;
    const validName = validateName(newUser.details.name || '');
    const validPhone = !newUser.details.phone || validatePhone(newUser.details.phone);
    const validLocalIdentifier = !customer.isCompany
        ? !newUser.details.cpr || validateCPR(newUser.details.cpr)
        : !newUser.details.cvr || validateCVR(newUser.details.cvr);
    const eitherValidEmailOrAddress = !!newUser.details.address || validateEmail(newUser.details.email);
    return (validName && validPhone && validLocalIdentifier && eitherValidEmailOrAddress);
};
export const validateNewCustomer = (newCustomer) => {
    if (!newCustomer)
        return false;
    if (newCustomer.referenceId === null || !newCustomer.referenceId)
        return false;
    if (newCustomer.users) {
        for (let i = 0; i < newCustomer.users.length; i++) {
            const user = newCustomer.users[i];
            if (!validateNewUserOnCustomer(newCustomer, user)) {
                return false;
            }
        }
    }
    return true;
};
export const NewUserOnCustomerSchema = z.object({
    lang: z.enum(Lang),
    contact: z.boolean(),
    relation: z.enum(['debtor', 'alternative-contact']),
    details: z.any(),
});
export const NewCustomerSchema = z.object({
    referenceId: z
        .string()
        .nullish()
        .transform((x) => x ?? null),
    defaultCaseGroupId: z
        .uuid()
        .nullish()
        .transform((x) => x ?? null),
    isCompany: z.boolean(),
    users: z
        .array(NewUserOnCustomerSchema)
        .nullish()
        .transform((x) => x ?? undefined),
});
export const UserOnCustomerDetailsSchema = z.object({
    name: z.string().nullish(),
    email: z.string().nullish(),
    carRegistrationNumber: z.string().nullish(),
    phone: PhoneSchema.nullish(),
    courtId: z.string().nullish(),
    address: AddressSchema.nullish(),
    birthdate: z.string().nullish(),
    cvr: z.string().nullish(),
    cpr: z.string().nullish(),
    ean: z.string().nullish(),
    description: z.string().nullish(),
    type: z.enum(AlternativeContactType).nullish(),
    alternativeContactReferenceId: z.string().nullish(),
});
export const PatchUserOnCustomerSchema = z.object({
    contact: z.boolean().optional(),
    lang: z.enum(Lang).optional(),
    details: z
        .object({
        name: z.string().optional(),
        email: z.string().nullish(),
        phone: PhoneSchema.nullish(),
        courtId: z.string().nullish(),
        address: AddressSchema.nullish(),
        birthdate: z.string().nullish(),
        cvr: z.string().nullish(),
        cpr: z.string().nullish(),
        ean: z.string().nullish(),
        description: z.string().nullish(),
        deliverability: z
            .object({
            eboks: z.array(z.object({
                recipient: EBoksRecipientSchema,
                success: z.boolean(),
                timestamp: z.string().datetime({ offset: true }),
                manualOverride: z.literal(true).optional(),
            })),
        })
            .optional(),
        type: z.enum(AlternativeContactType).nullish(),
        alternativeContactReferenceId: z.string().nullish(),
    })
        .optional(),
});
export const AddEventSchema = z.object({
    type: z.string(),
    details: z.any().optional(),
});
export const PatchCustomerSchema = z.object({
    referenceId: z
        .string()
        .nullish()
        .transform((x) => x ?? undefined),
    defaultCaseGroupId: z
        .uuid()
        .nullish()
        .transform((x) => x ?? undefined),
    isCompany: z.boolean().optional(),
    tags: z.array(TagSchema).optional(),
});
export const getDebtorsOnCustomer = (customer) => customer.users.filter((user) => user.relation === 'debtor');
export const getContactPerson = (customer) => {
    const user = customer.users.find((user) => user.contact);
    return user || null;
};
export const validateCPR = (cpr) => {
    const pattern = /^$|^\d{6}(-?){1}\d{4}$/;
    return pattern.test(cpr);
};
export const validateCVR = (cvr) => {
    const pattern = /^\d{8}$/;
    return pattern.test(cvr);
};
export const validateName = (name) => {
    const pattern = /^[^ ].{0,100}$/;
    return pattern.test(name);
};
export const defaultMergeRules = {
    caseStatus: [CaseStatus.PENDING, CaseStatus.VERIFIED],
    hasFoundation: false,
    doesNotHaveUpdateTypeIds: ISINCOURTUPDATESTYPES,
    hasActivePaymentPlan: false,
    preventMerge: false,
};
export const CaseMergeRulesSchema = z.object({
    caseStatus: z.array(z.enum(CaseStatus)),
    hasFoundation: z.boolean().nullish(),
    doesNotHaveUpdateTypeIds: z.array(z.uuid()),
    doesHaveUpdateTypeIds: z.array(z.uuid()).optional(),
    hasActivePaymentPlan: z.boolean().nullish(),
    preventMerge: z.boolean().optional(),
    adjustVariableCaseVouchers: z.boolean().optional(),
    caseVoucherConstraints: z
        .array(z.object({
        voucherTypeId: z.uuid(),
        timeConstraintInDays: z.number().optional(),
    }))
        .optional(),
});
export const getMatchForVoucher = (voucher, casesWithCaseVouchers) => {
    const sortEndedLast = (a, b) => (a.status === CaseStatus.ENDED ? 1 : -1) -
        (b.status === CaseStatus.ENDED ? 1 : -1);
    const matchVoucherAmountFn = (v) => Math.round(v.amount / 100) == Math.round(-voucher.amount / 100);
    const matchOnVoucherAmountCase = casesWithCaseVouchers
        .sort(sortEndedLast)
        .find((_case) => -helpers.overview.balance(_case.caseVouchers) >= voucher.amount &&
        _case.caseVouchers.find(matchVoucherAmountFn));
    if (matchOnVoucherAmountCase) {
        const matchingVoucher = matchOnVoucherAmountCase.caseVouchers.find(matchVoucherAmountFn);
        if (matchingVoucher) {
            return {
                caseId: matchOnVoucherAmountCase.caseId,
                caseVoucherId: matchingVoucher.caseVoucherId,
            };
        }
    }
    const matchBalanceCase = casesWithCaseVouchers
        .sort(sortEndedLast)
        .find((_case) => Math.abs(helpers.overview.balance(_case.caseVouchers) - voucher.amount) < 2500);
    if (matchBalanceCase) {
        return {
            caseId: matchBalanceCase.caseId,
            caseVoucherId: null,
        };
    }
    const matchBelowBalanceCase = casesWithCaseVouchers
        .sort(sortEndedLast)
        .find((_case) => -helpers.overview.balance(_case.caseVouchers) > voucher.amount);
    if (matchBelowBalanceCase) {
        return {
            caseId: matchBelowBalanceCase.caseId,
            caseVoucherId: null,
        };
    }
    return null;
};
//# sourceMappingURL=index.js.map